import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import breakpoint, { breakpointValues } from 'pricing-pages-ui/js/constants/Breakpoints';
import { PANTERA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterSideNav from 'ui-addon-react-router-dom/UIRouterSideNav';
import UIRouterSideNavItem from 'ui-addon-react-router-dom/UIRouterSideNavItem';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { NavItemEnum, SegmentedNavItems } from '../../../constants/routing/NavItems';
import { usePageParams } from '../../../hooks/usePageParams';
import CurrencyPicker from '../../common/CurrencyPicker';
import I18n from 'I18n';
const SideNavContainer = styled.div.withConfig({
  displayName: "SideNav__SideNavContainer",
  componentId: "fo2g46-0"
})(["z-index:1;min-width:200px;margin-top:10px;& > nav > ul{margin-left:12px;margin-right:12px;& > li > a{padding:14px;}}& > nav > hr{background-color:", ";width:90%;}@media (min-width:", "px) and (max-width:", "px){min-width:178px;}@media (min-width:", "px) and (max-width:", "px){min-width:110px;margin:0 20px 0 0;}"], PANTERA, breakpointValues.tablet, breakpointValues.sdMac - 1, breakpointValues.tabletPortrait, breakpointValues.tablet - 1);
const Container = styled.div.withConfig({
  displayName: "SideNav__Container",
  componentId: "fo2g46-1"
})(["margin:0 36px 0 0;position:sticky;top:85px;", ";"], breakpoint.tablet(_t || (_t = _`
    margin: 0 34px 0 0;
  `)));

const SideNav = ({
  selectedNavItem
}) => {
  const {
    tab
  } = usePageParams();
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(SideNavContainer, {
      children: Object.keys(SegmentedNavItems).map((navSection, index) => /*#__PURE__*/_jsx(UIRouterSideNav, {
        divider: index !== 0,
        headingText: I18n.text(`pricingPage.sidenav.sections.${navSection}`),
        children: SegmentedNavItems[navSection].map(navItem => {
          // const hideTabs = getHideTabs(navItem);
          const toValue = `/${navItem}${tab && NavItemEnum.FREE !== navItem && NavItemEnum.BUNDLE !== navItem ? `/${tab}` : ''}`;
          return /*#__PURE__*/_jsx(UIRouterSideNavItem, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `pricingPage.pages.products.tabs.${navItem}.tabTitle`
            }),
            className: selectedNavItem === navItem ? 'is-active' : undefined,
            to: createToObject(toValue)
          }, navItem);
        })
      }, navSection))
    }), /*#__PURE__*/_jsx(CurrencyPicker, {})]
  });
};

export default SideNav;